import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import BlogLeftSidebarTwoGridSectionOne from '../../components/blog-components/BlogLeftSidebarTwoGridSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const BlogLeftSidebarTwoGridOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Blog Left Sidebar Two Grid 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Blog Left Sidebar Two Grid 1"
        />
        
        <BlogLeftSidebarTwoGridSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default BlogLeftSidebarTwoGridOne;